// this file has API documentation in Yuidoc format:
// http://yui.github.io/yuidoc/syntax/index.html
// To generate the html view of the doc:
//
//    crunch $ grunt yuidoc
//
// or use "grunt watch" to recompile it automatically
// on every file change.
//
// Use "grunt http-server:doc" to read the docs in your browser.
//
/**
BuildSite Client-Side JavaScript API v0.3

https://docs.google.com/document/d/1GjA65mA2DczacNFkLaBa-498Cbn68YWasjmfAkUOA9E/edit#

@module buildsite.api

*/

//const socketIOClient = require('socket.io-client');
//const sailsIOClient = require('sails.io.js');
//io.sails.transports = ["polling"];
const io = require('sails.io.js-dist')( require('socket.io-client') );

import EventEmitter from 'events';
import api_object from './object';
import api_collection from './collection';

import { ERROR_CODES, NETWORK_ERROR, REGEXP_INVITE_CODE } from '../../../api/constants';
import { delay } from '../../../helpers/fn';

// Hack due to legacy code
Promise.prototype.done = Promise.prototype.then;
Promise.prototype.fail = Promise.prototype.catch;
Promise.prototype.always = Promise.prototype.finally;


/*********  api class  *********/

/**
An api instance performes communication to the app server.

It is an EventEmitter; use .on() to install your event handlers.
https://nodejs.org/api/events.html

Usage:

    var api = buildsite.api();
    api.on("online",initialize);
    api.on("offline",function() {...});
    api.on("mlac.error",function() {...});
    api.start();
    // create an object
    var o = api.object( "package", "file_1234" );


@class api
@static
*/

export class ApiBase extends EventEmitter {
    constructor(base, name) {
        super();

        this.base = base;
        this.name = name || "api_base";

        this.rev = window.buildsite.config.git_rev;
        this.online = true;
        this.ping_timer = 30;
        this.poll_timer = 30;
        // jQuery on an empty object, we are going to use this as our Queue
        this.ajaxQueue = $({});
        this.ajax_fail_count = 0;
        this.requestTimeout = 5 * 60 * 1000;

        this.object = api_object.bind(this);
        this.collection = api_collection.bind(this);

        let __api = this;

        __api.on("mlac.error", function(err) {
            //if (__api.online) __api.emit("offline");
            __api.clog( "MLAC error:", err.status, err.err );
        });

        __api.on("online", function() {
            this.online = true;
        });

        __api.on("offline", function() {
            this.online = false;
        });

        // queue length tracking
        __api.queue_len = 0;

        __api.on("request-queued",   () => this.queue_len++ );
        __api.on("request-finished", () => this.queue_len-- );

        if ("undefined" == typeof __api.pubsub) {
            __api.pubsub = io.socket;

            __api.pubsub.on('connect', () => {
                __api.clog("pubsub connect...");
                __api.socketId = __api.pubsub._raw.id;

                //if (!__api.do_reconnect) __api.emit("reconnect");
                //__api.do_reconnect = true;
            });

            __api.pubsub.on('reconnect', () => {
                __api.clog("pubsub reconnect...");
                __api.socketId = __api.pubsub._raw.id;
                __api.emit("reconnect");
                /*
                __api.get_rev().then(data => {
                    __api.clog("pubsub reconnect rev:", data, __api.rev == data);
                    __api.emit(__api.rev == data ? "reconnect" : "refresh");
                });
                */
            });

            __api.pubsub.on('service', (data) => {
                __api.clog("pubsub service listener got:", data);

                if (!data.event) return;

                if (data.event == "revision" && __api.rev != data.data) {
                    __api.clog("emit refresh");
                    __api.emit("refresh");
                    return;
                }

                if (data.event == "session_reset") {
                    __api.clog("emit session_reset");
                    __api.emit("session_reset", data.data);
                    return;
                }
            });
        }

        this.clog = function() {
            return Function.prototype.bind.call(console.log, console, __api.name + ':');
        }();
    }

    logEvent(...args) {
        if ("function" == typeof (window.buildsite || {}).logEvent) window.buildsite.logEvent(...args);
    }

    error_notify_ops = {
        'get': 0,
        'list': 0,
        'create': 1,
        'add_li': 1,
        'set_key': 1,
        'rem_li': 1,
        'move_li': 1,
        //'upload': 1, //outside of op
        'send': 0, //1 -- sending has own error handing
        'delete': 1,
        'undelete': 1,
        'forward': 0, //1 -- sending has own error handing
        'annotate': 1, // ?
        'duplicate': 1,
        'masterformatname': 0,
        'annotation_save': 1,
        'annotation_cancel': 1,
        'approve': 0, //1 -- has own error handling
        'suggest': 0,
        'add_spec': 1,
        'add': 1,
        'remove': 1,
        'packages': 0,
        'files': 0,
        'messages': 0,
        'download': 0,
        //'register': 0, //outside of op
        'update': 1,
        'update_company': 1,
        'logoupload': 1,
        'rename': 1
    }

    get_rev() {
        let api = this;

        api.clog("get_rev()");

        return this.queue_req({
            action:   "get_rev",
            dataType: "text",
        })
        .fail((xhr, status, err) => {
            api.clog("get_rev().fail: status", status);
        });
    }

    /**
    Makes a ping to the server, to check if the server is still available.

    May trigger the api's "online" and "offline" events (indirectly).

    @method ping
    @for api
    */
    ping() {
        let api = this;

        api.clog("ping()");

        this.queue_req({
            action:   "ping",
            dataType: "text",
        })
        .done(data => {
            // create new timer
            api.clog("ping().then: data", data);
            api._ping_set_timer();
        })
        .fail((xhr, status, err) => {
            // create new timer
            api.clog("ping().fail: status", status);
            api._ping_set_timer();
        });
    }

    _ping_set_timer() {
        this.intervalId = setTimeout(this.ping, this.ping_timer * 1000);
    }

    delay_ping() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this._ping_set_timer();
        }
    }

    /**
    Enables server pinging and other communication to the server. You must call this
    for the API to start talking to the server.

    Will trigger the api's "start" event on it's first call, or after a stop() call.

    PINGING SERVER IS NOW DISABLED. TO BE DISCUSSED. ���IKU

    @method start
    @for api
    */
    start() {
        if (!this.intervalId) {
            this.emit("start");
            this.ping();
        }
    }

    /**
    Disables pings to the server and all other communication to the server.

    May trigger the api's "stop" and "offline" events.

    @method stop
    @for api
    */
    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = 0;
        }

        this.emit("stop");
        this.clog("[mlac] stop all activity");

        // close global api objects
        for (let __oid in this.__objects) {
            if (this.__objects[__oid]) this.__objects[__oid].close();
        }
        // close global api list objects
        for (let __li in this.__lists) {
            if (this.__lists[__li]) this.__lists[__li].close();
        }

        //if (this.online) this.emit("offline");
        return true;
    }

    dataErrorCode(data) {
        let de = (data || {}).errors;
        return (de && de[0] && de[0].code) ? de[0].code : "";
    }

    ajax_retry_timeout() {
        return (++this.ajax_fail_count < 60)
            ? this.ajax_fail_count * 1000
            : 60 * 1000;
    }

    /*! jQuery Ajax Queue - v0.1.2pre - 2013-03-19
    * https://github.com/gnarf37/jquery-ajaxQueue
    * Copyright (c) 2013 Corey Frang; Licensed MIT */
    ajax_queue(ajaxOpts, ga_opts) {
        //this.clog("ajax_queue()");
        let api = this;
        let jqXHR,
            dfd = $.Deferred(),
            promise = dfd.promise();

        api.emit("request-queued", ajaxOpts);

        const headers = {};
        let tabId = sessionStorage.getItem('tid');

        if (!tabId) {
          tabId = cuid();

          sessionStorage.setItem('tid', tabId);
        }

        headers['x-tab'] = tabId;

        const inviteCode = document.location.href.match(REGEXP_INVITE_CODE);

        if (inviteCode) headers['x-ic'] = inviteCode[1];

        ajaxOpts.headers = _.assign(ajaxOpts.headers, headers, {});

        // run the actual query
        function doRequest( next ) {
            api.emit("request-sending", ajaxOpts);
            jqXHR = $.ajax( ajaxOpts );
            jqXHR.done((data, status, jqXHR) => {
                let failStatus = (data && data.status == "FAIL");

                if (failStatus || (jqXHR.status != 200 && jqXHR.status != 304)) {
                    let logevent = failStatus
                        ? api.dataErrorCode(data) != ERROR_CODES.NOT_ENOUGH_CAN
                        : true;

                    // not-enough-can processed with own dialog
                    if (logevent) {
                        api.logEvent({
                            category: 'api',
                            action: 'op-fail',
                            label: ajaxOpts.url + ':' + jqXHR.status + ':' + (data || {}).status
                        });
                    }
                } else {
                    // TODO: use method here!!!
                    ga_opts && ga_opts.event && api.logEvent(ga_opts.event);
                }

                //api.clog("ajaxQueue.done");
                api.emit("request-finished", ajaxOpts);
                api.ajax_fail_count = 0;

                if (!api.online) api.emit("online");

                if (failStatus) {
                    // clear queue -- no more always done by default
                    // need to add get snapshot ?
                    // may be abort on each dfd ?
                    let fail_code = api.dataErrorCode(data);

                    // skipErrorHandling == true => skip all default error handling
                    // skipErrorHandling == [] => skip specified codes
                    let performSkip = false, skipEH = ajaxOpts.__skipErrorHandling;

                    let custom_not_enough_can = skipEH === true || (Array.isArray(skipEH) && skipEH.indexOf(ERROR_CODES.NOT_ENOUGH_CAN) !== -1);

                    if (fail_code == ERROR_CODES.NOT_ENOUGH_CAN && !custom_not_enough_can) {
                        api.clog(ERROR_CODES.NOT_ENOUGH_CAN, ajaxOpts);
                        api.ajaxQueue.clearQueue(); // clear queue
                        api.emit(ERROR_CODES.NOT_ENOUGH_CAN, { req: ajaxOpts });
                        return dfd.reject(null, "FAILHANDLED"), next();
                    } else {
                        if (skipEH) {
                            performSkip = (
                                typeof skipEH == "boolean"
                                || (fail_code && skipEH.indexOf(fail_code) > -1)
                            );
                        }

                        if (!performSkip) {
                            api.ajaxQueue.clearQueue(); // clear queue
                            // writeable ops processed on op-fail
                            if (ajaxOpts.__writeable_op) {
                                api.emit("op-fail", { status: data.status, err: data.errors, op: ajaxOpts.__op });
                            } else {
                                api.emit("mlac.error", { status: "FAIL", errors: data.errors, type: "server" });
                            }
                            return dfd.reject(null, "FAILHANDLED"), next();
                        }
                    }

                    dfd.reject(null, "FAIL", data.errors, {performSkip});
                } else {
                    dfd.resolve(data, status);
                }

                next();
            })
            .fail((xhr, status, err) => {
                //api.clog("ajaxQueue.fail:", err);
                api.emit("request-finished", ajaxOpts);

                let branch = "other";

                if (xhr.readyState == 0) {
                    branch = "network-unavailable";
                } else if (xhr.readyState == 4) {
                    if (xhr.status == 401) {
                        branch = "unauth";
                    } else if (xhr.status == 502) {
                        branch = "server-unavailable";
                    } else {
                        branch = "server-internal";
                    }
                }

                switch(branch) {
                    case "network-unavailable":
                    case "server-unavailable":
                        // loss of network connection is not an mla-c error.
                        // go to offline mode, go on with attempts at sending the req later
                        if (api.online) api.emit("offline");

                        // try again the same request later
                        let retry_in = api.ajax_retry_timeout();

                        setTimeout(() => {
                            doRequest(next);
                        }, retry_in);

                        api.emit("request-queued",ajaxOpts);
                        api.clog("ajaxQueue.fail: " + branch + " " + status + "; retry in " + retry_in + " ms");
                        return;

                    case "unauth":
                        api.clog("ajaxQueue.fail: session expired, response status 401");
                        api.emit("unauth");
                        break;

                    case "server-internal":
                        // http response status 500. Server error
                    default:
                        // iku: i don't know what this case could be, honestly. Except response 500.
                        api.clog("ajaxQueue.fail: " + branch + "; http response " + status);
                        api.emit("mlac.error", { status, err, type: "server" });
                }

                api.stop();
                dfd.reject(xhr, status, err);
                next();
            });
        }

        // queue our ajax request
        api.ajaxQueue.queue( doRequest );

        return promise;
    }

    async fetch(args, context) {
      let url;
      let writeable_op = false;
      let opts = { ...args };
      let ga_opts = {};

      if (opts.action) {
        url = this.base + '/' + opts.action;

        delete opts.action;
      } else {
        url = [ this.base, opts.type, opts.id, opts.op ].join('/');

        if (this.error_notify_ops[opts.op]) writeable_op = true;

        if (context) {
          ga_opts.event = {
            category: 'api',
            action: (context.type === 'collection' ? context.collection_of : context.type) + ':' + opts.op,
            value: 1
          };
        }
      }

      if (opts.get_query) {
        url += '?' + new URLSearchParams({ ...opts.get_query, _: Date.now() });

        delete opts.get_query;
      } else if (!opts.data) {
        url += '?_=' + Date.now();
      }

      if (opts.snapshot) {
        delete opts.snapshot;

        ga_opts = {};
      }

      let ajaxOpts = {
        __writeable_op: writeable_op,
        __op: opts.op,
        ifModified: true
      };

      if (opts.data) {
        if (opts.data.skipErrorHandling) {
          ajaxOpts.__skipErrorHandling = opts.data.skipErrorHandling;

          delete opts.data.skipErrorHandling;
        }

        if (typeof opts.data.ifModified !== 'undefined') {
          ajaxOpts.ifModified = opts.data.ifModified;

          delete opts.data.ifModified;
        }

        if (opts.data.omitSocket && opts.data.omitSocket == -2) {
          if (this.socketId) {
            opts.data.omitSocket = this.socketId;
          } else {
            delete opts.data.omitSocket;
          }
        }

        ajaxOpts.data = opts.data || {};
        delete opts.data;
      }

      ajaxOpts = { ...ajaxOpts, ...opts };

      this.emit('request-queued', ajaxOpts);

      const headers = {};
      let tabId = sessionStorage.getItem('tid');

      if (!tabId) {
        tabId = cuid();

        sessionStorage.setItem('tid', tabId);
      }

      headers['x-tab'] = tabId;

      const inviteCode = document.location.href.match(REGEXP_INVITE_CODE);

      if (inviteCode) headers['x-ic'] = inviteCode[1];

      const request = opts => new Promise((resolve, reject) => {
        (async () => {
          let response;

          try {
            response = await fetch(url, {
              method: opts.data ? 'POST' : 'GET',
              headers: {
                'content-type': 'application/json;charset=utf-8',
                ...headers
              },
              cache: 'no-store',
              ...(opts.data ? { body: JSON.stringify(opts.data) }: {})
            });
          } catch (err) {
            console.error('fetch error:', err);
            return reject(err);
          }

          let json;

          console.log('fetch response.status:', response.status, response.ok);
          if (response.ok) {
            json = await response.json();
          } else {
            return reject({statusCode: response.status, errors: await response.text()});
          }

          const failStatus = json && json.status === 'FAIL';

          if (failStatus || (response.status !== 200 && response.status !== 304)) {
            if (failStatus ? this.dataErrorCode(json) !== ERROR_CODES.NOT_ENOUGH_CAN : true) {
              this.logEvent({
                category: 'api',
                action: 'op-fail',
                label: url + ':' + response.status + ':' + (json || {}).status
              });
            }
          } else {
            ga_opts && ga_opts.event && this.logEvent(ga_opts.event);
          }

          this.emit('request-finished', opts);
          this.ajax_fail_count = 0;

          if (!this.online) this.emit('online');

          if (failStatus) {
            let fail_code = this.dataErrorCode(json);
            let performSkip = false, skipEH = opts.__skipErrorHandling;
            let custom_not_enough_can = skipEH === true || (Array.isArray(skipEH) && skipEH.indexOf(ERROR_CODES.NOT_ENOUGH_CAN) !== -1);

            if (fail_code === ERROR_CODES.NOT_ENOUGH_CAN && !custom_not_enough_can) {
              this.clog(ERROR_CODES.NOT_ENOUGH_CAN, opts);
              this.emit(ERROR_CODES.NOT_ENOUGH_CAN, { req: opts });

              return reject({ status: 'FAILHANDLED' });
            } else {
              if (skipEH) performSkip = typeof skipEH === 'boolean' || (fail_code && skipEH.indexOf(fail_code) > -1);

              if (!performSkip) {
                if (opts.__writeable_op) {
                  this.emit('op-fail', { status: json.status, err: json.errors, op: opts.__op });
                } else {
                  this.emit('mlac.error', { status: 'FAIL', errors: json.errors, type: 'server' });
                }

                return reject({ status: 'FAILHANDLED' });
              }
            }

            reject({ status: 'FAIL', errors: json.errors, performSkip });
          } else {
            if (json && response.statusText !== 'notmodified') {
              resolve({ data: json, status: response.statusText });
            } else {
              resolve({ status: response.statusText });
            }
          }
        })();
      });

      return Promise.race([
        request(ajaxOpts),
        new Promise((_, reject) => setTimeout(() => reject(1), this.requestTimeout))
      ]).catch((statusCode, statusText, errors, opts) => {
        this.emit('request-finished', ajaxOpts);

        let branch = NETWORK_ERROR.OTHER;

        if (statusCode === 0) {
          branch = NETWORK_ERROR.NETWORK_UNAVAILABLE;
        } else if (statusCode === 1) {
          branch = NETWORK_ERROR.REQUEST_TIMEOUT;
        } else if (statusCode === 401) {
          branch = NETWORK_ERROR.UNAUTHENTICATED;
        } else if (statusCode === 502) {
          branch = NETWORK_ERROR.SERVER_UNAVAILABLE;
        } else {
          branch = NETWORK_ERROR.SERVER_INTERNAL;
        }

        switch(branch) {
          case NETWORK_ERROR.NETWORK_UNAVAILABLE: case NETWORK_ERROR.SERVER_UNAVAILABLE:
            if (this.online) this.emit('offline');

            this.clog('ajaxQueue.fail: ' + branch + ' ' + statusCode + '; retry in ' + this.ajax_retry_timeout() + ' ms');

            this.emit('request-queued', ajaxOpts);

            return delay(() => request(ajaxOpts), this.ajax_retry_timeout());
          case NETWORK_ERROR.UNAUTHENTICATED:
            this.clog('ajaxQueue.fail: session expired, response status 401');

            this.emit('unauth');

            break;
          case NETWORK_ERROR.SERVER_INTERNAL:
          default:
            this.clog('ajaxQueue.fail: ' + branch + '; http response ' + statusCode);

            this.emit('mlac.error', { statusCode, errors, type: 'server' });
        }

        this.stop();

        return Promise.reject({}, statusText, errors, opts);
      });
    }

    queue_req(req_opts_in, context) {
        //this.clog("queue_req()");
        let url;
        let writeable_op = false;
        let req_opts = $.extend(true, {}, req_opts_in); // deep copy
        let ga_opts = {};

        if (req_opts.action) {
            url = this.base + '/' + req_opts.action;
            delete req_opts.action;
        } else {
            url = [this.base, req_opts.type, req_opts.id, req_opts.op].join('/');

            if (this.error_notify_ops[req_opts.op]) writeable_op = true;

            if (context) {
                ga_opts.event = {
                    category: 'api',
                    action: (context.type == "collection" ? context.collection_of : context.type) + ':' + req_opts.op,
                    value: 1
                };
            }
        }

        if (req_opts.get_query) {
            let gq = [];

            for (let k in req_opts.get_query) {
              gq.push(k + "=" + req_opts.get_query[k]);
            }

            url += "?" + gq.join('&');
            delete req_opts.get_query;
        }

        if (req_opts.snapshot) {
            delete req_opts.snapshot;
            ga_opts = {};
        }

        let ajaxOpts = {
            __writeable_op: writeable_op,
            __op:           req_opts.op,
            url:            url,
            method:         req_opts.data ? 'POST' : 'GET',
            contentType:    'application/json',
            cache:          false,
            dataType:       'json',
            ifModified:     true
        };

        if (req_opts.data) {
            if (req_opts.data.skipErrorHandling) {
                ajaxOpts.__skipErrorHandling = req_opts.data.skipErrorHandling;
                delete req_opts.data.skipErrorHandling;
            }

            if ("undefined" != typeof req_opts.data.ifModified) {
                ajaxOpts.ifModified = req_opts.data.ifModified;
                delete req_opts.data.ifModified;
            }

            if (req_opts.data.omitSocket && req_opts.data.omitSocket == -2) { // auto fill omitSocket by socketId
                if (this.socketId) {
                    req_opts.data.omitSocket = this.socketId;
                } else {
                    delete req_opts.data.omitSocket;
                }
            }

            $.extend(ajaxOpts, { data: JSON.stringify(req_opts.data || {}) });
            delete req_opts.data;
        }

        $.extend(ajaxOpts, req_opts);

        let dfd = $.Deferred();

        this.ajax_queue(ajaxOpts, ga_opts).done((data, status) => {
            //this.clog("queue_req: request success:", status);
            if (data && status != "notmodified") {
                dfd.resolve(data, status);
            } else {
                dfd.resolve(null, status);
            }
        })
        .fail((xhr, status, err, fail_opts) => {
            //this.clog("queue_req: request failed:", status);
            //this.clog(err);
            dfd.reject(xhr, status, err, fail_opts);
        });

        return dfd.promise();
    }

    test() {
        this.emit("test");
    }

    pubsubResub() {}
}

/*********  api events  *********/

/**
This is tiggered when a connection to server has been successfully established,
through pings or other API requests.

@event online
*/
/**
This is tiggered when the pings or other requests to server result in connection errors.

@event offline
*/
/**
This is tiggered when an error happens in the api or in a request to the server.

Possible values for the first argument (besides null) are "timeout", "error",
"abort", and "parsererror". When an HTTP error occurs, errorThrown receives
the textual portion of the HTTP status, such as "Not Found" or "Internal Server Error."

Both arguments are passed on from jQuery' ajax() method's error handlers:
http://api.jquery.com/jquery.ajax/

@event error
@param {String} Status
@param {String} errorThrown
*/
/**
This is triggered right before or right after the first ping request was sent to the server.

@event start
*/
/**
This is tiggered if & when the stop() method was invoked on the api.

@event stop
*/

